import * as React from "react";
import {Field} from "react-final-form";
import {EstadosIndependiente as estadosIndependientes} from "../modelo/EstadosIndependiente";

export default class EstadosIndependiente extends React.Component<EstadosIndependienteProps> {

    render() {
        const {className} = this.props;
        return (
            <Field name={this.props.name}>
                {({input, meta}) => (
                    <div>
                        <select {...input} className={className ? className.concat(" form-control") : "form-control"}>
                            <option value={""}>Selecciona...</option>
                            {estadosIndependientes.map(estado => {
                                return <option key={estado} value={estado}>{estado}</option>;
                            })}
                        </select>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }

}

interface EstadosIndependienteProps {
    name: string,
    className?: string
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/reportes/componentes/EstadosIndependiente.tsx